import * as d3 from 'd3';
import { ChartData } from 'components/chart/data/ChartData';

export interface GradientCreator {
  createGradient: (
    selection: d3.Selection<SVGGElement, ChartData[], SVGGElement, undefined>,
    gradientId: string
  ) => void;
}

export const createLinearTwoColourGradientCreator = (bottomColour: string, topColour: string): GradientCreator => {
  return {
    createGradient: (selection: d3.Selection<SVGGElement, ChartData[], SVGGElement, undefined>, gradientId: string) => {
      let lg = selection
        .append('defs')
        .append('linearGradient')
        .attr('id', gradientId)
        .attr('x1', '0%')
        .attr('x2', '0%')
        .attr('y1', '0%')
        .attr('y2', '100%'); //since it's a vertical linear gradient
      lg.append('stop').attr('offset', '0%').style('stop-color', topColour).style('stop-opacity', 0.1);

      lg.append('stop').attr('offset', '100%').style('stop-color', bottomColour).style('stop-opacity', 0.1);
    },
  };
};

export const transparentUpperAndLowerGradientCreator = (colour: string): GradientCreator => {
  return {
    createGradient: (selection: d3.Selection<SVGGElement, ChartData[], SVGGElement, undefined>, gradientId: string) => {
      let lg = selection
        .append('defs')
        .append('linearGradient')
        .attr('id', gradientId)
        .attr('x1', '0%')
        .attr('x2', '0%')
        .attr('y1', '0%')
        .attr('y2', '100%'); //since it's a vertical linear gradient
      lg.append('stop').attr('offset', '0%').style('stop-color', colour).style('stop-opacity', 0.0);
      lg.append('stop').attr('offset', '50%').style('stop-color', colour).style('stop-opacity', 0.8);

      lg.append('stop').attr('offset', '100%').style('stop-color', colour).style('stop-opacity', 0.0);
    },
  };
};
